import styled from 'styled-components';

import { colors } from 'config/theme';

export const SidebarWrapper = styled.div<{ expanded: boolean }>`
  padding: 1em;
  padding-left: ${(props) => !props.expanded && '0.5em'};
  padding-right: ${(props) => !props.expanded && '0.5em'};
  border-right: 2px solid ${colors.lightGray};
  min-width: ${(props) => (props.expanded ? '300px' : 'max-content')};
  max-width: ${(props) => (props.expanded ? '300px' : 'max-content')};

  header {
    align-items: center;
    color: #263238;
    display: flex;
    justify-content: space-between;
  }

  hr {
    padding-top: 1em;
  }

  section {
    padding-top: 1em;

    .MuiFormControl-root {
      margin-top: 1em;
    }
  }
`;
